import { render, staticRenderFns } from "./GraphControlsWidget.vue?vue&type=template&id=1aa1704d&scoped=true"
import script from "./GraphControlsWidget.vue?vue&type=script&lang=js"
export * from "./GraphControlsWidget.vue?vue&type=script&lang=js"
import style0 from "./GraphControlsWidget.vue?vue&type=style&index=0&id=1aa1704d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa1704d",
  null
  
)

export default component.exports